import React from 'react'
import { useTranslation } from 'react-i18next'
import { Divider, Link, Stack, Typography } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import LoginForm from './components/LoginForm'
import { useTheme } from '@mui/material/styles'
import { GoogleLogin } from '@react-oauth/google'
import { Box } from '@mui/system'
import { useAuth } from '../../hooks/useAuth'

export const SignIn = () => {
  const { t } = useTranslation()
  const { palette } = useTheme()
  const { signWithGoogleToken } = useAuth()
  return (
    <>
      <Helmet>
        <title> Login | DWF </title>
      </Helmet>

      <Typography variant='h4' mb={6}>
        {t('signIn.accountAccess')}
      </Typography>

      <Box>
        <GoogleLogin
          width='2000'
          text='signin_with'
          onSuccess={async (credentialResponse: any) => {
            console.log(credentialResponse.credential)
            await signWithGoogleToken(credentialResponse.credential)
          }}
          onError={() => {
            console.log('Login Failed')
          }}
        />
      </Box>
      <Divider sx={{ my: 3 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {t('general.or')}
        </Typography>
      </Divider>

      <LoginForm />
      <Divider sx={{ my: 3, mt: 8 }}></Divider>
      <Stack
        direction="row"
        spacing={1}
        justifyContent="center"
        alignItems="center"
        bgcolor={palette.grey[800]}
        color={palette.grey[400]}
        borderRadius={1}
        p={2}
      >
        <Typography variant="body1" color={palette.grey[100]}>
          {t('signIn.link.notMember')}
        </Typography>
        <Link variant="subtitle1" underline="hover" color={palette.primary.light} href="/signUp">{t('signIn.link.signUp')}</Link>
      </Stack>
    </>
  )
}
